import { ky } from './ky';
import { ProductPurchasableReason } from './product';

/**
 * 장바구니 아이템. 백엔드 `CartItemDto`(v1/commerce/data/CartDto.kt)와 매칭된다.
 * 금액 필드는 백엔드 BigDecimal 을 JSON number 로 전달받는다.
 */
export interface CartItemDto {
  id: number;
  productId: number;
  productTitle?: string | null;
  variantId: number;
  optionName?: string | null;
  optionValue?: string | null;
  skuCode?: string | null;
  quantity: number;
  unitPriceAmount?: number | null;
  currencyCode?: string | null;
  lineTotalAmount?: number | null;
  purchasable: boolean;
  purchasableReason?: ProductPurchasableReason | null;
}

/**
 * 장바구니 DTO. 백엔드 `CartDto`와 매칭된다.
 */
export interface CartDto {
  id?: number | null;
  memberId: number;
  currencyCode?: string | null;
  itemCount: number;
  totalQuantity: number;
  subtotalAmount: number;
  items: CartItemDto[];
}

export interface CartItemAddRequest {
  productId: number;
  variantId: number;
  quantity: number;
}

export interface CartItemUpdateRequest {
  quantity: number;
}

/**
 * 장바구니 API 클라이언트.
 * 백엔드 `CartController`(/v1/cart)와 매칭된다. (lone-backend work_item 16)
 * 로그인(멤버) 세션 기준으로 동작하므로 인증 가드가 필요한 화면에서 사용한다.
 */
export default class CartService {
  /** 내 장바구니 조회 */
  async getCart() {
    const response = await ky.get('v1/cart');
    return (await response.json()) as CartDto;
  }

  /** 장바구니에 상품 옵션 담기 */
  async addItem(request: CartItemAddRequest) {
    const response = await ky.post('v1/cart/items', { json: request });
    return (await response.json()) as CartDto;
  }

  /** 장바구니 아이템 수량 변경 */
  async updateItem(itemId: number, request: CartItemUpdateRequest) {
    const response = await ky.patch(`v1/cart/items/${itemId}`, { json: request });
    return (await response.json()) as CartDto;
  }

  /** 장바구니 아이템 삭제 */
  async removeItem(itemId: number) {
    const response = await ky.delete(`v1/cart/items/${itemId}`);
    return (await response.json()) as CartDto;
  }
}
